import { DatePipe } from "@angular/common";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { Contacts } from "@awesome-cordova-plugins/contacts/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Network } from "@awesome-cordova-plugins/network/ngx";
import { OpenNativeSettings } from "@awesome-cordova-plugins/open-native-settings/ngx";
import { SocialSharing } from "@awesome-cordova-plugins/social-sharing/ngx";
import { Config } from "@ionic/angular";
import { BackupsModule } from "../modules/backups/backups.module";
import { SecurityModule } from "../modules/security/security.module";
import { ArchivingService } from "./archiving.service";
import { GalleryService } from "./gallery.service";
import { PlatformService } from "./platform.service";
import { PopoverService } from "./popover.service";

function initializeAppFactory(psvcPlatform: PlatformService): () => Promise<void> {
	return () => psvcPlatform.initPlatformInfo();
}

/** Ce module regroupe les services généraux de la bibliothèque et les instancie. */
@NgModule({
	imports: [SecurityModule, BackupsModule],
	exports: [],
	declarations: [],
	providers: [
		SocialSharing,
		OpenNativeSettings,
		InAppBrowser,
		DatePipe,
		Network,
		Contacts,
		Config,
		PopoverService,
		GalleryService,
		ArchivingService,
		provideAppInitializer(() => {
			const initializerFn = initializeAppFactory(inject(PlatformService));
			return initializerFn();
		})
	]
})
export class ServiceModule {}
